// multiSheetWorkflow/internals — pure helpers used internally by
// useMultiSheetWorkflow. Extracted so the public hook surface is clear
// and these utilities are testable without instantiating the hook. (#22)

import type { BlockType, WorkflowSheet } from '@/types/workflow';

export const GRID_SIZE = 20;
export const MAX_HISTORY = 50;

// sessionStorage key used to remember the active sheet across a page
// refresh within the same tab. Per-tab (not localStorage) so multiple
// tabs can look at different sheets of the same document without fighting.
export const ACTIVE_SHEET_KEY = 'fw-active-sheet-index';

export const snapToGrid = (v: number): number =>
  Math.round(v / GRID_SIZE) * GRID_SIZE;

export const getDefaultBlockName = (type: BlockType): string => {
  const names: Record<BlockType, string> = {
    'create-user': 'Aktivitet',
    'disable-mailbox': 'Kommunikation',
    'delete-m365': 'System',
    'send-email': 'Notifiering',
    'webhook': 'Händelse',
    'add-to-group': 'Intressent',
    'condition': 'Beslut',
    'sheet-link': 'Länk',
    'general': 'Process',
  };
  return names[type] || 'Okänt block';
};

export function createEmptySheet(name: string): WorkflowSheet {
  return { id: crypto.randomUUID(), name, blocks: [], connectors: [], groups: [] };
}

export function readStoredActiveSheet(maxIndex: number): number {
  try {
    const raw = sessionStorage.getItem(ACTIVE_SHEET_KEY);
    if (raw == null) return 0;
    const n = parseInt(raw, 10);
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.min(n, maxIndex));
  } catch {
    return 0;
  }
}
